import { useState } from 'react';
import CustomImage from '../../fragments/custom-image/CustomImage';
import { SmartLink } from '../../fragments/smart-link/SmartLink';
import Button from '../../fragments/button/Button';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper.jsx';
import ComponentHeading from '../../fragments/heading/ComponentHeading';

import Media from '../media/Media.jsx';
import Wysiwyg from '../wysiwyg/Wysiwyg.jsx';

function formatNewsDate(dateString) {
  if (!dateString) return null;
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

export default function NewsArticle({ pageData, blocks, BLOCK_COMPONENTS }) {
  const [copied, setCopied] = useState(false);
  const authors = pageData?.newsData?.authors || [];
  const date = formatNewsDate(pageData?.newsData?.date);

  function handleCopy() {
    if (typeof window === 'undefined') return;
    navigator.clipboard.writeText(window.location.href).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <ComponentWrapper block={{ theme: 'dynamic' }} className="NewsArticle">
      {pageData.newsData?.description && (
        <div className="l-grid">
          <ComponentHeading heading={pageData.newsData.description} />
        </div>
      )}
      <div className="l-grid">
        <div className="l-grid__col l-grid__col--l-3-12">
          <div className="NewsArticle-sidebar">
            {authors.length > 0 && (
              <div className="NewsArticle-authors">
                {authors.map((author) => {
                  const content = (
                    <>
                      {author.image && (
                        <div className="NewsArticle-authorImage colorDynamicBg">
                          <CustomImage
                            image={author.image}
                            fill={true}
                            sizes="80px"
                          />
                        </div>
                      )}
                      {author.name && (
                        <span className="NewsArticle-authorName headingStrong">
                          {author.name}
                        </span>
                      )}
                      {author.position && (
                        <span className="NewsArticle-authorPosition">
                          {author.position}
                        </span>
                      )}
                    </>
                  );
                  return (
                    <div key={author.id} className="NewsArticle-author">
                      {/* {author.uri ? (
                        <SmartLink
                          href={author.uri}
                          className="NewsArticle-authorLink"
                        >
                          {content}
                        </SmartLink>
                      ) : ( */}
                      <div className="NewsArticle-authorLink">{content}</div>
                      {/* )} */}
                    </div>
                  );
                })}
              </div>
            )}

            <div className="NewsArticle-meta">
              {/* {date && (
                <div className="NewsArticle-metaItem">
                  <span>{date}</span>
                </div>
              )} */}
              <div className="NewsArticle-metaItem">
                <span>3 min read</span>
              </div>
              <div className="NewsArticle-metaItem">
                <Button
                  buttonLabel={copied ? 'Copied!' : 'Copy article link'}
                  icon="copy"
                  theme="tertiary"
                  size="small"
                  onClick={handleCopy}
                />
              </div>
            </div>
          </div>
        </div>

        {/* <div className="l-grid__col l-grid__col--l-7-12 l-grid__col--l-push-1-12"> */}
        <div className="l-grid__col l-grid__col--l-7-12 ">
          <div className="NewsArticle-content">
            {blocks.map((block, i) => {
              const Component = BLOCK_COMPONENTS[block.type];

              if (!Component) return null;

              return <Component block={block} key={i} />;
            })}
          </div>
        </div>
      </div>
    </ComponentWrapper>
  );
}
